import useGetSimulations from 'hooks/useGetSimulations';
import { useState } from 'react';

import ErrorMessage from './ErrorMessage';
import ScenarioItemSkeleton from './ScenarioItemSkeleton';
import SimulationItem from './SimulationItem';
import { Action, setHeaders, simulationButtonActions } from './utils';
import './_simulation_styles.scss';

const domain = import.meta.env.VITE_SIMULATION_ROUTE;

interface SimulationsListProps {
    selected: string | undefined;
    selectSimulation(i: string): void;
}

const SimulationsList = ({ selected, selectSimulation }: SimulationsListProps) => {
    const [isTriggeringSimulation, setIsTriggeringSimulation] = useState<boolean>(false);
    const [isTriggerSimulationError, setIsTriggerSimulationError] = useState<boolean>(false);
    const { scenarios, isLoading, refresh } = useGetSimulations();

    const closeError = () => {
        setIsTriggerSimulationError(false);
    };

    const triggerSimulation = async (vin: string) => {
        const scenario = scenarios?.find(item => item.vin === vin);
        let url = '';
        if (scenario !== null && scenario !== undefined) {
            switch (simulationButtonActions.get(scenario.state)?.action) {
                case Action.START:
                    url = `${domain}/simulator-adapter-service/api/v2/simulation/${vin}/start`;
                    break;
                case Action.STOP:
                    url = `${domain}/simulator-adapter-service/api/v2/simulation/${vin}/stop`;
                    break;
                case Action.INITIALIZE:
                    url = `${domain}/simulator-adapter-service/api/v1/simulation/initialize/${vin}`;
                    break;
            }
        }
        setIsTriggerSimulationError(false);
        setIsTriggeringSimulation(true);
        try {
            await fetch(url, {
                method: 'POST',
                headers: await setHeaders(),
            });
        } catch (error) {
            setIsTriggerSimulationError(true);
            console.error(error);
        } finally {
            setIsTriggeringSimulation(false);
            refresh();
        }
    };

    return (
        <div className='ScenariosList'>
            {isTriggerSimulationError && (
                <ErrorMessage message='Error while triggering simulation.' onClose={closeError} />
            )}
            {}
            <button
                data-testid='button-refresh'
                disabled={isLoading}
                onClick={refresh}
                className='ScenariosList__refresh-button'
            >
                Refresh list
            </button>
            {isLoading ? (
                <ScenarioItemSkeleton />
            ) : !scenarios?.length ? (
                <i className='ScenariosList__no-scenarios'>No simulation available</i>
            ) : (
                <ul className='ScenariosList__scenarios-list'>
                    {scenarios.map(_ => (
                        <li key={_.vin} className='ScenariosList__scenario-item'>
                            <SimulationItem
                                vin={_.vin}
                                selected={selected}
                                simulationState={_.state}
                                selectSimulation={selectSimulation}
                                isLoading={isTriggeringSimulation}
                                onClick={triggerSimulation}
                                startedAt={_.startedAt}
                            />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SimulationsList;
